import { useState } from 'react';
import Button from '@/components/ui/Button';

interface TextInputProps {
  onSubmit: (text: string) => void;
  disabled: boolean;
}

export default function TextInput({ onSubmit, disabled }: TextInputProps) {
  const [answer, setAnswer] = useState('');

  const handleSubmit = () => {
    const trimmed = answer.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    setAnswer('');
  };

  return (
    <div className="flex flex-col gap-3">
      <textarea
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        disabled={disabled}
        rows={4}
        placeholder="Type your answer here..."
        className="w-full rounded-xl border border-border bg-card px-4 py-3 font-sans text-base text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors resize-none disabled:opacity-50"
      />
      <Button
        onClick={handleSubmit}
        disabled={disabled || !answer.trim()}
        fullWidth
      >
        Submit Answer
      </Button>
    </div>
  );
}
